<template>
  <div
    class="
      col-span-6
      sm:col-span-3
      xl:col-span-2
      flex flex-col
      justify-end
      items-center
    "
    v-if="loading"
  >
    <LoadingIcon icon="three-dots" class="w-8 h-8" />
  </div>
  <div v-if="!loading">
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <MapPinIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('branch.detail') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link
          :to="{ name: 'side-menu-branches' }"
          tag="a"
          class="btn shadow-md flex items-center"
        >
          <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
        </router-link>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5 pb-5 items-center">
      <div
        class="
          flex flex-col
          lg:flex-row
          border-b border-gray-200
          dark:border-dark-5
          pb-5
          -mx-5
        "
      >
        <div
          class="flex flex-1 px-5 items-center justify-center"
        >
          <img
            :src="branch.imageWide"
            class="center"
            v-if="branch.imageWide"
            style="max-width: 1264px; max-height: 300px;"
          />
        </div>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        class="
          flex flex-col
          lg:flex-row
          border-b border-gray-200
          dark:border-dark-5
          pb-5
          -mx-5
        "
      >
        <div
          class="flex flex-1 px-5 items-center justify-center lg:justify-start"
        >
          <div
            class="
              w-20
              h-20
              sm:w-24 sm:h-24
              flex-none
              lg:w-32 lg:h-32
              image-fit
              relative
            "
          >
            <img
              alt="Service image"
              class="rounded-full"
              :src="branch.image"
              v-if="branch.image"
            />
          </div>
          <div class="ml-5">
            <div
              class="
                w-24
                sm:w-40
                truncate
                sm:whitespace-normal
                font-medium
                text-lg
              "
            >
              {{ branch.name }}
            </div>
            <div class="text-gray-600">
              {{ branch.description.sk_SK }}
            </div>
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
        >
          <div class="font-medium text-center lg:text-left lg:mt-3">
            {{ $t('common.detail') }}
          </div>
          <div
            class="
              flex flex-col
              justify-center
              items-center
              lg:items-start
              mt-4
            "
          >
            <div class="truncate sm:whitespace-normal flex items-center">
              <WatchIcon class="w-4 h-4 mr-2" />
              <ul>
                <li v-if="branch.openHours.openMonday">
                  {{ $t('common.days.monday') }}
                  {{
                    branch.openHours.monday === null
                      ? 'nonstop'
                      : branch.openHours.monday
                  }}
                </li>
                <li v-if="branch.openHours.openTuesday">
                  {{ $t('common.days.tuesday') }}
                  {{
                    branch.openHours.tuesday === null
                      ? 'nonstop'
                      : branch.openHours.tuesday
                  }}
                </li>
                <li v-if="branch.openHours.openWednesday">
                  {{ $t('common.days.wednesday') }}
                  {{
                    branch.openHours.wednesday === null
                      ? 'nonstop'
                      : branch.openHours.wednesday
                  }}
                </li>
                <li v-if="branch.openHours.openThursday">
                  {{ $t('common.days.thursday') }}
                  {{
                    branch.openHours.thursday === null
                      ? 'nonstop'
                      : branch.openHours.thursday
                  }}
                </li>
                <li v-if="branch.openHours.openFriday">
                  {{ $t('common.days.friday') }}
                  {{
                    branch.openHours.friday === null
                      ? 'nonstop'
                      : branch.openHours.friday
                  }}
                </li>
                <li v-if="branch.openHours.openSaturday">
                  {{ $t('common.days.saturday') }}
                  {{
                    branch.openHours.saturday === null
                      ? 'nonstop'
                      : branch.openHours.saturday
                  }}
                </li>
                <li v-if="branch.openHours.openSunday">
                  {{ $t('common.days.sunday') }}
                  {{
                    branch.openHours.sunday === null
                      ? 'nonstop'
                      : branch.openHours.sunday
                  }}
                </li>
              </ul>
            </div>
            <div class="truncate sm:whitespace-normal flex items-center mt-3">
              <EyeIcon class="w-4 h-4 mr-2" v-if="branch.visible" />
              <EyeOffIcon class="w-4 h-4 mr-2" v-if="!branch.visible" />
              {{ $t('common.visibility') }}
            </div>
            <div class="truncate sm:whitespace-normal flex items-center mt-3">
              <CheckCircleIcon class="w-4 h-4 mr-2" v-if="branch.active" />
              <CircleIcon class="w-4 h-4 mr-2" v-if="!branch.active" />
              {{ $t('common.active') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        class="
          flex flex-col
          lg:flex-row
          pb-5
          -mx-5
        "
      >
        <div
          class="flex flex-1 px-5 items-center justify-center lg:justify-start"
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <ServiceBindList :selectedServices="branch.services" />
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <EmployeeBindList :selectedEmployees="branch.employees" />
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <ResourceBindList :selectedResources="branch.resources" />
          </div>
        </div>
      </div>
    </div>
    <div class="intro-y box p-5 mt-5">
      <Calendar :branch="this.$route.params.uuid" />
    </div>
  </div>
  <!-- BEGIN: Failed Notification Content -->
  <div
    id="failed-load-notification-content"
    class="toastify-content hidden flex"
  >
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('branch.notLoaded') }}!</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, ref } from 'vue'
import branchApi from '@/services/branches/branch.api'
import Toastify from 'toastify-js'
import Calendar from '../../components/reservations/Calendar.vue'
import ServiceBindList from '@/components/services/ServiceBindList.vue'
import EmployeeBindList from '@/components/employees/EmployeeBindList.vue'
import ResourceBindList from '@/components/resources/ResourceBindList.vue'

export default defineComponent({
  components: {
    Calendar,
    EmployeeBindList,
    ResourceBindList,
    ServiceBindList
  },
  methods: {},
  computed: {
    console: () => console
  },
  data() {
    return {
      branch: {}
    }
  },
  mounted() {
    branchApi.getDetail(this.$route.params.uuid).then(
      response => {
        this.branch = response.data
        this.loading = false
      },
      error => {
        console.log(error)
        Toastify({
          node: cash('#failed-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.$router.push({ name: 'side-menu-branches' })
      }
    )
  },
  setup() {
    const loading = ref(true)

    return {
      loading
    }
  }
})
</script>
